<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Cobros
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")

                            
                            v-text-field(outline
                            readonly
                            v-model="form.metodo"
                            prepend-inner-icon="description"
                            label="Método de pago:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.vendedor"
                            prepend-inner-icon="description"
                            label="Vendedor:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.cliente.cli_des"
                            prepend-inner-icon="description"
                            label="Cliente:")
                            
                            v-text-field(outline
                            v-if='form.titular'
                            readonly
                            v-model="form.titular"
                            prepend-inner-icon="description"
                            label="Titular:")
                            
                            v-select(outline
                            readonly
                            :items='itemsF'
                            multiple
                            v-model="form.facturas"
                            prepend-inner-icon="description"
                            label="Facturas:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.monto"
                            prepend-inner-icon="description"
                            label="Monto:")
                            
                            v-textarea(outline
                            readonly
                            v-model="form.descripcion"
                            prepend-inner-icon="description"
                            label="Descripción:")

                            div(style='display: flex;justify-content: center;margin: 10px;' v-if='form.bauche')
                              a(:href='ruta + form.bauche' target='_blank')
                                img(:src='ruta + form.bauche' style='width: 425px;height: auto;')

                            v-text-field(outline
                              v-if='form.estatus === "Aprobado" || form.estatus === "Procesado"'
                              v-model="form.nroCobro"
                              prepend-inner-icon="description"
                              label="Nro. de cobro:")

                            v-textarea(outline
                              v-if='form.observacion'
                              readonly
                              v-model="form.observacion"
                              prepend-inner-icon="description"
                              label="Observación:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(v-if='form.estatus === "Aprobado"' style="background:green;border-radius:10px;", @click.native='save("P")') Procesado
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:green;border-radius:10px;", @click.native='save("A")') Aprobar
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:red;border-radius:10px;", @click.native='save("R")') Rechazar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs4)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs4 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:items='filtros' v-model="seleccionFiltro" label="Estatus" @change='cambiarFiltro()')
            v-flex(xs4 style='display: flex;align-items: center;justify-content: flex-end;')
              //- v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
              //-   template(v-slot:activator='{ on, attrs }')
              //-     v-text-field(v-model='dateFormatted' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' @blur='date = parseDate(dateFormatted)' v-on='on')
              //-   v-date-picker(v-model='date' no-title='' @input='modal = false' dark='')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
              v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#ff6500' style='font-size: 1.70rem;') search
              vue-excel-xlsx( v-if='resultados && resultados.length > 0' :data='dataExcel' :columns='columnsExcel' :filename="'Says-Cobros'" :sheetname="'sheetname'")
                img(src='../assets/iconos/excel.png', style='height: 60px;width: auto;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Cobros
        v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ transform(props.item.fechaC)}}
            td {{ transform(props.item.fechaP)}}
            td {{ props.item.vendedor }}
            td(v-if='props.item.cliente && props.item.cliente.cli_des') {{ props.item.cliente.cli_des }}
            td(v-else) N/A
            td {{ props.item.metodo }}
            td {{ props.item.monto}}
            td(v-if='props.item.referencia') {{ props.item.referencia}}
            td(v-else) N/A
            td(v-if='props.item.nroCobro') {{ props.item.nroCobro}}
            td(v-else) N/A
            td {{ props.item.estatus}}
            td.justify-start.layout.px-0
                v-btn.mx-0(v-if='mod' icon, @click='editItem(props.item)', style='margin-top: -7px;')
                    v-icon(color='teal') edit
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "Cobros",
  data: vm => ({
    ruta: server + ":" + port,
    dates: [],
    loading: false,
    dialog4: false,
    seleccionFiltro: 'todos',
    filtros: [
      {
        text: "Todos",
        value: "todos"
      },
      {
        text: "Pendientes",
        value: "Pendiente"
      },
      {
        text: "Aprobados",
        value: "Aprobado"
      },
      {
        text: "Rechazados",
        value: "Rechazado"
      },
      {
        text: "Procesados",
        value: "Procesado"
      },
    ],
    itemsF: [],
    dataExcel: [],
    columnsExcel: [
      {
        label: "Fecha",
        field: "fechaC",
      },
      {
        label: "Fecha de pago",
        field: "fechaP",
      },
      {
        label: "Vendedor",
        field: "vendedor",
      },
      {
        label: "Cliente",
        field: "cliente",
      },
      {
        label: "Método",
        field: "metodo",
      },
      {
        label: "Monto",
        field: "monto",
      },
      {
        label: "Referencia",
        field: "referencia",
      },
      {
        label: "Nro. Cobro",
        field: "nroCobro",
      },
      {
        label: "Facturas",
        field: "facturas",
      },
      {
        label: "Descripción",
        field: "descripcion",
      },
      {
        label: "Estatus",
        field: "estatus",
      },
    ],
    pagination: {
      sortBy: 'fechaC', // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    search: "",
    form: {
      nroCobro: "",
      titular: "",
      vendedor: "",
      cliente: {},
      facturas: [],
      monto: null,
      descripcion: "",
      bauche: "",
      metodo: "",
      observacion: "",
      estatus: "",
      fechaP: "",
      fechaC: ""
    },
    dialog: false,
    resultadosres: [],
    resultados: [],
    headers: [
      { text: "Fecha", value: "fechaC" },
      { text: "Fecha de pago", value: "fechaP" },
      { text: "Vendedor", value: "vendedor" },
      { text: "Cliente", value: "cliente.cli_des" },
      { text: "Método", value: "metodo" },
      { text: "Monto", value: "monto" },
      { text: "Referencia", value: "referencia" },
      { text: "Nro. Cobro", value: "nroCobro" },
      { text: "Estatus", value: "estatus" },
      { text: "Acción" }
    ],
    defaultForm: {
      nroCobro: "",
      titular: "",
      vendedor: "",
      cliente: {},
      facturas: [],
      monto: null,
      descripcion: "",
      bauche: "",
      metodo: "",
      observacion: "",
      estatus: "",
      fechaP: "",
      fechaC: ""
    },
    cre: "",
    mod: "",
    elm: "",
    img: ""
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    dateRangeText () {
      let todos = []
      let desde
      let hasta
      if (this.dates && this.dates[0])  {
        desde = this.formatDate(this.dates[0])
        todos.push(desde)
      }
      if (this.dates && this.dates[1]) {
        hasta = this.formatDate(this.dates[1])
        todos.push(hasta)
      }
      return todos.join(' ~ ')
    },
  },
  watch: {
    dates (val) {
      if (val && val.length > 2) {
        let res = []
        res.push(val[0])
        res.push(val[2])
        this.$nextTick(() => {
          this.dates = res
        })
      }
      if (val && val.length == 2 && val[0] > val[1]) {
        this.$swal.fire(
          "¡Atención!",
          "La fecha final debe ser mayor a la fecha inicial.",
          "error"
        );
        let res = []
        res.push(val[0])
        this.$nextTick(() => {
          this.dates = res
        })
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
    let hasta = this.$moment().format('YYYY-MM-DD')
    this.dates.push(desde)
    this.dates.push(hasta)
    this.verificacion();
    this.initialize();
  },
  methods: {
    transform(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY")
    },
    cambiarFiltro() {
      let data = this.seleccionFiltro
      if (data) {
        this.resultados = []
        this.dataExcel = []
        let res = []
        for (let i = 0; i < this.resultadosres.length; i++) {
          const el = this.resultadosres[i];
          let fcct = ""
          for (let j = 0; j < el.facturas.length; j++) {
            const el2 = el.facturas[j];
            if (i == (el.facturas.length-1)) {
              fcct += el2.nro_doc.trim() + "."
            } else fcct += el2.nro_doc.trim() + ", "
          }
          if (data === "todos") {
            res.push(el)
            this.dataExcel.push({
              fechaC: this.$moment(el.fechaC).format('DD-MM-YYYY H:mm A'),
              fechaP: this.$moment(el.fechaP).format('DD-MM-YYYY H:mm A'),
              vendedor: el.vendedor,
              cliente: el.cliente.cli_des,
              metodo: el.metodo,
              monto: el.monto,
              referencia: (el.referencia) ? el.referencia : "N/A",
              nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
              facturas: fcct,
              descripcion: el.descripcion,
              estatus: el.estatus
            })
          } else if (el.estatus === data) {
            res.push(el)
            this.dataExcel.push({
              fechaC: this.$moment(el.fechaC).format('DD-MM-YYYY H:mm A'),
              fechaP: this.$moment(el.fechaP).format('DD-MM-YYYY H:mm A'),
              vendedor: el.vendedor,
              cliente: el.cliente.cli_des,
              metodo: el.metodo,
              monto: el.monto,
              referencia: (el.referencia) ? el.referencia : "N/A",
              nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
              facturas: fcct,
              descripcion: el.descripcion,
              estatus: el.estatus
            })
          }
        }
        this.$nextTick(() => {
          this.resultados = res
        })
      }
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminsays.permisos.length; i++) {
        if (this.$store.state.adminsays.permisos[i].ruta === "Cobros") {
          for (
            let j = 0;
            j < this.$store.state.adminsays.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminsays.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminsays.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminsays.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    buscarFecha() {
      this.dialog4 = true
      let hasta = (this.dates && this.dates[1]) ? this.dates[1] : null
      if (this.dates && this.dates[0]) {
        Api.get("cobros/admin?desde="+this.dates[0]+'&hasta='+hasta)
        .then(res => {
          this.dialog4 = false
          this.resultados = [];
          this.resultadosres = [];
          this.dataExcel = []
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              const el = res.data[i];
              if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
              let fact = []
              for (let j = 0; j < el.facturas.length; j++) {
                const el2 = el.facturas[j];
                if (typeof el2 === "string") {
                  fact = JSON.parse(el2)
                } else fact.push(el2)
              }
              el.facturas = fact
              let fcct = ""
              for (let j = 0; j < el.facturas.length; j++) {
                const el2 = el.facturas[j];
                if (i == (el.facturas.length-1)) {
                  fcct += el2.nro_doc.trim() + "."
                } else fcct += el2.nro_doc.trim() + ", "
              }
              this.resultados.push(el)
              this.resultadosres.push(el)
              this.dataExcel.push({
                fechaC: this.$moment(el.fechaC).utc().format('DD-MM-YYYY H:mm A'),
                fechaP: this.$moment(el.fechaP).utc().format('DD-MM-YYYY H:mm A'),
                vendedor: el.vendedor,
                cliente: el.cliente.cli_des,
                metodo: el.metodo,
                monto: el.monto,
                referencia: (el.referencia) ? el.referencia : "N/A",
                nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
                facturas: fcct,
                descripcion: el.descripcion,
                estatus: el.estatus
              })
            }
          }
        }).catch(err=>{
          console.log(err)
          this.dialog4 = false
        })
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.dates = []
      let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
      let hasta = this.$moment().format('YYYY-MM-DD')
      this.dates.push(desde)
      this.dates.push(hasta)
      this.dataExcel = []
      Api.get("cobros/admin?desde="+this.dates[0]+'&hasta='+this.dates[1]).then(res => {
        this.resultados = []
        this.resultadosres = []
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
            let fact = []
            for (let j = 0; j < el.facturas.length; j++) {
              const el2 = el.facturas[j];
              if (typeof el2 === "string") {
                fact = JSON.parse(el2)
              } else fact.push(el2)
            }
            el.facturas = fact
            let fcct = ""
            for (let j = 0; j < el.facturas.length; j++) {
              const el2 = el.facturas[j];
              if (i == (el.facturas.length-1)) {
                fcct += el2.nro_doc.trim() + "."
              } else fcct += el2.nro_doc.trim() + ", "
            }
            this.resultados.push(el)
            this.resultadosres.push(el)
            this.dataExcel.push({
              fechaC: this.$moment(el.fechaC).utc().format('DD-MM-YYYY H:mm A'),
              fechaP: this.$moment(el.fechaP).utc().format('DD-MM-YYYY H:mm A'),
              vendedor: el.vendedor,
              cliente: el.cliente.cli_des,
              metodo: el.metodo,
              monto: el.monto,
              referencia: (el.referencia) ? el.referencia : "N/A",
              nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
              facturas: fcct,
              descripcion: el.descripcion,
              estatus: el.estatus
            })
          }
        }
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
    },
    editItem(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = []
      this.form.facturas = []
      for (let i = 0; i < item.facturas.length; i++) {
        const el = item.facturas[i];
        this.itemsF.push({
          value: el.nro_doc,
          text: el.nro_doc
        })
        this.form.facturas.push(el.nro_doc)
      }
      this.form._id = item._id;
      this.dialog = true;
    },
    save(item) {
      let info
      if (item === "P") {
        info = {
          _id: this.form._id,
          nroCobro: this.form.nroCobro,
          estatus: "Procesado"
        }
      } else {
        info = {
          _id: this.form._id,
          estatus: (item === "A") ? "Aprobado" : "Rechazado"
        }
      }
      if (info.estatus === "Rechazado") {
        this.$swal.fire({
          title: 'Motivo del rechazo',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.dismiss) {
            console.log("paso cancel")
          } else if (result.value) {
            info.observacion = result.value
            this.loading = true;
            Api.put("cobros", info)
              .then(() => {
                this.form = Object.assign({}, this.defaultForm);
                this.dialog = false;
                this.$swal.fire(
                  "Felicidades.!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.loading = false;
                this.buscarFecha();
              })
              .catch(err => {
                console.log(err);
                this.loading = false;
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
            });
          } else {
            this.$swal.fire(
              "¡Atención!",
              "Debe ingresar el motivo del rechazo.",
              "error"
            );
          }
        })
      } else {
        this.loading = true;
        Api.put("cobros", info)
          .then(() => {
            this.form = Object.assign({}, this.defaultForm);
            this.dialog = false;
            this.$swal.fire(
              "Felicidades.!",
              "Modificación realizada exitosamente.",
              "success"
            );
            this.loading = false;
            this.buscarFecha();
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
        });
      }
    }
  }
};
</script>
<style lang="scss">
</style>
